import getConfig from 'next/config';

export default function getEnv<TEnv extends string | undefined = undefined>(
  env?: TEnv,
): TEnv extends undefined
  ? 'staging' | 'production' | 'development'
  : string | undefined {
  if (env) {
    return getConfig().publicRuntimeConfig[env];
  }
  return getConfig().publicRuntimeConfig.ENVIRONMENT || 'development';
}
